// TeacherForm.tsx
import { FormikProvider } from "formik";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
import CustomInputText from "../../components/forms/CustomInputText";
import CustomDropdown from "../../components/forms/CustomDropdown";
import CustomDatepicker from "../../components/forms/CustomDatepicker";
import { ApiResponse } from "../../services/base/apiResponse";
import {
  AcademicPositionResponse,
  AcademicRankResponse,
  DepartmentResponse,
  TeacherStatusResponse,
} from "../../models/dtos";
import { identificationTypesApi } from "../../services/nomenclatures/identificationTypesApi";
import { countriesApi } from "../../services/nomenclatures/countriesApi";

const TeacherForm = ({
  formik,
  departments,
  academicPositions,
  academicRanks,
  teacherStatuses,
}: {
  formik: any;
  departments: ApiResponse<DepartmentResponse[]> | undefined;
  academicPositions: ApiResponse<AcademicPositionResponse[]> | undefined;
  academicRanks: ApiResponse<AcademicRankResponse[]> | undefined;
  teacherStatuses: ApiResponse<TeacherStatusResponse[]> | undefined;
}) => {
  const { data: identifications } = identificationTypesApi.useGetIdentificationTypesQuery();
  const { data: countries } = countriesApi.useGetCountriesQuery();

  return (
    <FormikProvider value={formik}>
      <div className="flex justify-content-center flex-wrap">
        <Card className="w-full mt-4">
          <Divider />
          <div className="col-12">
            <div className="card">
              <div className="p-fluid formgrid grid">
                <div className="col-4">
                  <CustomInputText id="firstName" label="Име" className="mr-2" required />
                </div>
                <div className="col-4">
                  <CustomInputText id="middleName" label="Презиме" className="mr-2" required />
                </div>
                <div className="col-4">
                  <CustomInputText id="lastName" label="Фамилия" className="mr-2" required />
                </div>
                <div className="col-4">
                  <CustomInputText id="firstNameEn" label="Име (на английски)" className="mr-2" />
                </div>
                <div className="col-4">
                  <CustomInputText id="middleNameEn" label="Презиме (на английски)" className="mr-2" />
                </div>
                <div className="col-4">
                  <CustomInputText id="lastNameEn" label="Фамилия (на английски)" className="mr-2" />
                </div>

                <div className="col-4">
                  <CustomInputText id="teacherNumber" label="Номер на преподавател" className="mr-2" />
                </div>

                <div className="field col-12 md:col-4">
                  <CustomInputText id="email" label="Личен E-mail" required />
                </div>
                <div className="field col-12 md:col-4">
                  <CustomInputText id="userEmail" label="Служебен E-mail" />
                </div>
                <div className="field col-12 md:col-3">
                  <CustomDropdown
                    id="identificationTypeId"
                    label="Идентификационен тип"
                    options={identifications?.data ?? []}
                    optionLabel="name"
                    optionValue="identificationTypeId"
                    placeholder="Изберете опция"
                    required
                  />
                </div>
                <div className="field col-12 md:col-3">
                  <CustomInputText id="egn" label="Идентификационен номер" required />
                </div>
                <div className="field col-12 md:col-3">
                  <CustomInputText id="phone" label="Телефонен номер" required />
                </div>
                <div className="field col-12 md:col-4">
                  <CustomDropdown
                    id="citizenshipCountryId"
                    label="Гражданство"
                    options={countries?.data ?? []}
                    optionLabel="name"
                    optionValue="countryId"
                    placeholder="Изберете опция"
                    required
                    filter
                    showClear
                  />
                </div>
                <Divider />
                <div className="field col-12 md:col-4">
                  <CustomDropdown
                    id="departmentId"
                    label="Катедра"
                    options={departments?.data ?? []}
                    optionLabel="name"
                    optionValue="departmentId"
                    placeholder="Изберете опция"
                    required
                    filter
                    showClear
                  />
                </div>
                <div className="field col-12 md:col-2">
                  <CustomDatepicker id="employmentStartDate" label="Дата на назначаване" required />
                </div>
                <div className="field col-12 md:col-2">
                  <CustomDatepicker id="employmentEndDate" label="Дата на освобождаване" />
                </div>
                <div className="field col-12 md:col-3">
                  <CustomInputText id="room" label="Кабинет" />
                </div>
                <Divider />
                <div className="field col-12 md:col-4">
                  <CustomDropdown
                    id="academicPositionId"
                    label="Академична длъжност"
                    options={academicPositions?.data ?? []}
                    optionLabel="name"
                    optionValue="academicPositionId"
                    placeholder="Изберете опция"
                    required
                    filter
                    showClear
                  />
                </div>
                <div className="field col-12 md:col-4">
                  <CustomDropdown
                    id="academicRankId"
                    label="Научна степен"
                    options={academicRanks?.data ?? []}
                    optionLabel="name"
                    optionValue="academicRankId"
                    placeholder="Изберете опция"
                    filter
                    showClear
                  />
                </div>
                <div className="field col-12 md:col-4">
                  <CustomDropdown
                    id="teacherStatusId"
                    label="Преподавателски статус"
                    options={teacherStatuses?.data ?? []}
                    optionLabel="name"
                    optionValue="teacherStatusId"
                    placeholder="Изберете опция"
                    required
                    filter
                    showClear
                  />
                </div>

                <Divider />

                <div className="field col-12 md:col-4">
                  <CustomInputText id="normHours" label="Норматив часове" />
                </div>
                <div className="field col-12">
                  <CustomInputText id="note" label="Бележка" type="multiline" />
                </div>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </FormikProvider>
  );
};

export default TeacherForm;
